import { graphql, useStaticQuery } from 'gatsby';
import { getBlogDataList, getFilterList } from '../utils/utils';

function getBlogData() {
  const raw_data = useStaticQuery(graphql`
    query blogQuery {
      allSanityBlog(sort: {fields: DateOfPublication, order: DESC}) {
        edges {
          node {
            showCTA
            headline
            featuredBlog
            BilateralContainerLayoutStyleListTypes
            DateOfPublication
            _rawBlogImage
            _rawExcerpt
            SelectFilter {
              FilterTitle
            }
            _type
            _rawSlug
            _rawBody
          }
        }
      }
      allSanityFilter {
        edges {
          node {
            FilterTitle
          }
        }
      }
    }
  `);
  const jsonData = {
    blogData: getBlogDataList(raw_data.allSanityBlog.edges),
    filterList: getFilterList(raw_data.allSanityFilter.edges),
  };
  return jsonData;
}

export default getBlogData;
